export const GET_BENEFITS_V2 = ({ percentDiscount, freePoints }) => {
  const benefits = [
    "Access to <strong>500+ lessons</strong>",
  ]

  const creditInUsd = Math.floor((freePoints ?? 0) / 100)
  if (creditInUsd) {
    benefits.push(`<strong>$${creditInUsd} credit</strong> for live coaching`)
  }

  if (percentDiscount) {
    benefits.push(`${percentDiscount}% off more coaching`)
  }

  return benefits
}

export const GET_BENEFITS_V3 = ({ percentDiscount }) => {
  const benefits = [
    "Access to <strong>500+ lessons</strong>",
    "<strong>$40 credit</strong> for live coaching",
  ]
  if (percentDiscount) {
    benefits.push(`${percentDiscount}% off more coaching`)
  }
  benefits.push("<strong>Rank up guarantee*</strong> ")
  return benefits
}

export const LEAGUE_BENEFITS = [
  "<strong>Access to Diamond+ coaching</strong>",
  "<strong>Your games analyzed</strong> by pros",
  "<strong>Exclusive access</strong> to courses with the world's best pros",
]

export const FORTNITE_BENEFITS = [
  "<strong>Access to Top 1%+ coaching</strong>",
  "<strong>Your games analyzed</strong> by pros",
  "<strong>Exclusive access</strong> to courses with the world's best pros",
]

export const VALORANT_BENEFITS = [
  "<strong>Access to Diamond+ coaching</strong>",
  "<strong>Your games analyzed</strong> by pros",
  "<strong>Exclusive access</strong> to courses with the world's best pros",
]

export const GET_BENEFITS_V4 = ({ percentDiscount, freePoints }) => {
  const benefits = ["50% off all Bootcamps"]
  if (freePoints) {
    benefits.push(`${freePoints} ProGuides coaching credit points`)
  }
  if (percentDiscount) {
    benefits.push(`${percentDiscount}% off more coaching`)
  }
  benefits.push("Lifetime access to 500+ lessons")
  return benefits
}



// WEBPACK FOOTER //
// ./src/constants/membership.js